import React from 'react';
import { useDispatch } from 'react-redux';
import { apiAction } from '../../../store/generalSlice';

const SimpleField = (props) => {
  const dispatch = useDispatch();
  const { action, fieldName, field, state, setState } = props;

  const handleInputChange = (id, value, handler) => {
    handler((prevState) => ({
      ...prevState,
      [id]: { ...prevState[id], value },
    }));
  };

  const handleUseSourceChange = (id, isUseSource, handler) => {
    handler((prevState) => ({
      ...prevState,
      [id]: { ...prevState[id], isUseSource },
    }));
    dispatch(
      apiAction({
        reduxField: 'action',
        route: `actions/updateDuplicateAction`,
        actionId: action._id,
        fieldName,
        changes: { ...state, [id]: { ...state[id], isUseSource } },
      })
    );
  };

  const SaveButton = () => {
    return (
      <>
        <button
          className='btn btn-sm btn-success mt-2'
          onClick={() => {
            dispatch(
              apiAction({
                reduxField: 'action',
                route: `actions/updateDuplicateAction`,
                actionId: action._id,
                fieldName,
                changes: { ...state },
              })
            );
          }}
        >
          Save
        </button>
      </>
    );
  };
  return (
    <div key={field.id} className='col-md-6 p-3 border'>
      <label>
        <b>{field.id}: </b>
        {field.description}
      </label>
      {field.options.length > 0 ? (
        <>
          <select
            className='form-control'
            value={state[field.id] ? state[field.id].value : undefined}
            onChange={(e) => handleInputChange(field.id, e.target.value, setState)}
            disabled={state[field.id] ? state[field.id].isUseSource : null}
          >
            <option value={''}>Choose Value</option>
            {field.options.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          {state[field.id]?.value !== action[fieldName][field.id]?.value ? <SaveButton /> : null}
        </>
      ) : (
        <>
          <input
            type={field.type === 'number' ? 'number' : 'text'}
            className='form-control'
            defaultValue={state[field.id] ? state[field.id].value : null}
            onChange={(e) => handleInputChange(field.id, e.target.value, setState)}
            disabled={state[field.id] ? state[field.id].isUseSource : null}
          />
          {state[field.id]?.value !== action[fieldName][field.id]?.value ? <SaveButton /> : null}
        </>
      )}
      <div className='form-check mt-2'>
        <input
          type='checkbox'
          className='form-check-input'
          checked={state[field.id] ? state[field.id].isUseSource : null}
          onChange={(e) => handleUseSourceChange(field.id, e.target.checked, setState)}
        />
        <label className='form-check-label'>Use Source</label>
      </div>
    </div>
  );
};

export default SimpleField;
